import "./instrument";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

if (import.meta.env.DEV) {
  const params = new URLSearchParams(window.location.search);
  if (params.get("sentry-test") === "1") {
    params.delete("sentry-test");
    const search = params.toString();
    const cleaned =
      window.location.pathname + (search ? `?${search}` : "") + window.location.hash;
    window.history.replaceState(null, "", cleaned);
    setTimeout(() => {
      throw new Error(
        `[debug-sentry] Synthetic test error from clairo-web-v3 at ${new Date().toISOString()}`,
      );
    }, 0);
  }
}

createRoot(document.getElementById("root")!).render(<App />);
